export default "__VITE_PUBLIC_ASSET__8bf2cfd8__"